import {listGender} from "data/list";
import moment from "moment";
import DilateStatusCard from "components/common/DilateStatusCard/DilateStatusCard";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
import {DataFormField} from "types/models/input-field-type";
import {ColumnsEdit} from "types/models/column-table-edit";
import {birthday2Age, convertDateStringToDateTimezone_7} from "helper/common";
import {formatPhoneNumber} from "helper/format-phone";
import {loaiBNOptions} from "assets/constants/kbnt-category";
import PatientTypeColumn from "components/common/ColumnColors/KCBTypeColumn/PatientTypeColumn";
import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import KCBStatusColumn from "components/common/ColumnColors/KCBTypeColumn/KCBStatusColumn";
const {INPUT, DATE_DISABLE, DATE, COMBO_BOX, NUMBER} = FIELD_TYPE;

const fields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã phiếu khám",
    name: "maPhieuKham",
    expand: false,
  },
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    expand: false,
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    name: "tenBenhNhan",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
    expand: false,
  },

  {
    type: COMBO_BOX,
    label: "Giới tính",
    name: "gioiTinh",
    expand: true,
    options: listGender,
  },
  {
    type: NUMBER,
    label: "Số thẻ BHYT",
    name: "maTheBhyt",
    expand: true,
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "soDienThoai",
    expand: true,
  },
  {
    type: INPUT,
    label: "Họ tên NV",
    name: "hoTenNV",
    expand: true,
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái BH",
    placeholder: "Chọn",
    name: "trangThaiBH",
    options: JSON.parse(localStorage.getItem("TTBH")),
    expand: true,
  },
  {
    type: COMBO_BOX,
    label: "Loại KCB",
    placeholder: "Chọn",
    name: "loaiKCB",
    options: JSON.parse(localStorage.getItem("loaiKCB")),
    expand: true,
  },
  {
    type: DATE,
    label: "Ngày tạo từ",
    name: "ngayTaoTu",
    disableDate: false,
    expand: true,
  },
  {
    type: DATE,
    label: "Ngày tạo đến",
    name: "ngayTaoDen",
    expand: true,
    disableDate: false,
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái CĐHA",
    name: "trangThai",
    options: JSON.parse(localStorage.getItem("TTPhieu")),
    expand: true,
  },

  {
    type: COMBO_BOX,
    label: "Khu KCB",
    placeholder: "Chọn",
    name: "khuKham",
    options: JSON.parse(localStorage.getItem("khuKham")),
    expand: true,
  },
];

const allColumns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    isResizable: true,
    width: 40,
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    isResizable: true,
    align: "center",
    width: 60,
  },
  {
    title: "Mã PK",
    dataIndex: "idPhieuKham",
    show: true,
    isResizable: true,
    align: "center",
    width: 60,
  },
  {
    title: "Tên BN",
    dataIndex: "hoTen",
    show: true,
    isResizable: true,
    align: "left",
    disabledCheck: true,
    width: 150,
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    show: true,
    isResizable: true,
    disabledCheck: true,
    align: "left",
    render: text => {
      if (text == "0") {
        return "Nam";
      } else if (text == "1") {
        return "Nữ";
      } else return "";
    },
    width: 70,
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    show: true,
    isResizable: true,
    align: "center",
    render: (text, record) =>
      text
        ? convertDateStringToDateTimezone_7(text).format(FORMAT_TIME.dayFull)
        : "",
    width: 100,
  },
  {
    title: "Số điện thoại",
    key: "dienThoai",
    dataIndex: "dienThoai",
    disabledCheck: true,
    render: v => v && formatPhoneNumber(v),
    align: "right",
  },
  {
    title: "Tuổi",
    key: "tuoi",
    dataIndex: "tuoi",
    render: (text, record: {ngaySinh: Date}) =>
      record.ngaySinh ? birthday2Age(record.ngaySinh) : "",
    show: true,
    isResizable: true,
    width: 50,
    disabledCheck: true,
    align: "center",
  },
  {
    title: "Ngày tạo",
    key: "ngayTao",
    dataIndex: "ngayTao",
    render: (text, record) =>
      text ? moment(text).format(FORMAT_TIME.dateTime) : "",
    show: true,
    isResizable: true,
    width: 100,
    align: "center",
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChiTongHop",
    show: false,
    isResizable: true,
    align: "left",
    width: 180,
  },
  {
    title: "Loại KCB",
    key: "loaiKCB",
    dataIndex: "loaiKCB",
    show: true,
    isResizable: true,
    disabledCheck: true,
    width: 130,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("loaiKCB")).find(
          option => option.value === text
        )?.label || "";
      return <KCBTypeColumn label={ten} />;
    },
  },
  {
    title: "Loại bệnh nhân",
    dataIndex: "loaiBenhNhans",
    key: "loaiBenhNhans",
    show: true,
    isResizable: true,
    disabledCheck: true,
    width: 130,
    align: "center",
    render: text => {
      const loaiBN =
        loaiBNOptions.find(option => option.value === text?.[0])?.label || "";
      return <PatientTypeColumn label={loaiBN} />;
    },
    // isResizable: true
  },
  {
    title: "Tên NV",
    key: "nvThucHien",
    dataIndex: "nvThucHien",
    show: true,
    isResizable: true,
    width: 150,
  },
  {
    title: "Trạng thái CĐHA",
    key: "trangThai",
    dataIndex: "trangThai",
    show: true,
    isResizable: true,
    disabledCheck: true,
    width: 150,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("TTPhieu")).find(
          option => option.value === text
        )?.label || "";
      return <KCBStatusColumn label={ten} />;
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    isResizable: true,
    align: "center",
    width: 120,
  },
];

export {fields, allColumns};
